import parse from 'html-react-parser';
import { cn } from '@/app_lib/utils/utils';

export const DescriptionParser = ({ className, content }: { className?: string; content: string }) => {
  return <span className={cn('description-parser contents', className)}>{parse(content)}</span>;
};
